import {chakra, defineRecipe, HTMLChakraProps, RecipeVariantProps} from '@chakra-ui/react';

// A round orange counter (open comments). The number is centred by flexbox: in a flex box `textAlign`
// does nothing, so a single digit would sit at the left of the minimum width.
const countBadgeRecipe = defineRecipe({
    className: 'count-badge',
    base: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        borderRadius: 'full',
        bg: 'orange.400',
        color: 'white',
        fontWeight: 'bold',
        lineHeight: '1',
        whiteSpace: 'nowrap',
        fontVariantNumeric: 'tabular-nums',
    },
    variants: {
        size: {
            sm: {minW: '16px', h: '16px', px: '1', fontSize: '10px'},
            md: {minW: '20px', h: '20px', px: '1.5', fontSize: 'xs'},
        },
    },
    defaultVariants: {size: 'md'},
});

const BadgeRoot = chakra('span', countBadgeRecipe);

interface CountBadgeProps extends Omit<HTMLChakraProps<'span'>, 'children'>, RecipeVariantProps<typeof countBadgeRecipe> {
    count: number;
    /** Larger counts show as "<max>+". */
    max?: number;
}

/** A notification-style count; renders nothing for zero. */
export function CountBadge({count, max, ...props}: CountBadgeProps) {
    if (count <= 0) return null;
    return <BadgeRoot {...props}>{max && count > max ? `${max}+` : count}</BadgeRoot>;
}
